import { askAboutAndReveal } from "../../../state/chatActions";
import type { AcquirerProfile } from "../../../data/types";
import { fmtEur, fmtPct } from "./format";
import styles from "./BinStrip.module.css";

interface BinStripProps {
  acquirer: AcquirerProfile;
}

export function BinStrip({ acquirer }: BinStripProps) {
  return (
    <div className={styles.strip}>
      {acquirer.bins.map((b) => {
        const state =
          b.binVampRatio >= b.vampExcessive
            ? "critical"
            : b.binVampRatio >= b.vampAboveStandard
              ? "warn"
              : "health";
        return (
          <button
            key={b.bin}
            type="button"
            className={`${styles.card} ${styles[state]}`}
            title={`drill into the ${b.ccy} bin`}
            onClick={() =>
              askAboutAndReveal(
                `break down the ${b.ccy} bin (${b.bin}). ${fmtPct(b.binVampRatio)} vamp on ${fmtEur(b.binMonthlyVol)}/mo. above-standard kicks in at ${fmtPct(b.vampAboveStandard, 2)}, excessive at ${fmtPct(b.vampExcessive, 2)} — which merchants are dragging this bin up and how much headroom do we have?`,
                "intelligence",
                { kind: "cohort" }
              )
            }
          >
            <header className={styles.header}>
              <span className={styles.bin}>{b.bin}</span>
              <span className={styles.ccy}>{b.ccy}</span>
            </header>
            <div className={styles.ratio}>
              <span className={styles.ratioValue}>{fmtPct(b.binVampRatio)}</span>
              <span className={styles.ratioLabel}>vamp</span>
            </div>
            <div className={styles.meta}>
              <span>{fmtEur(b.binMonthlyVol)}/mo</span>
              <span className={styles.metaDim}>
                {(b.binMonthlyTxns / 1000).toFixed(0)}k txns
              </span>
            </div>
          </button>
        );
      })}
    </div>
  );
}
